import { CREATE_BIKE_MODEL_VARIANTS_REQUEST, CREATE_BIKE_MODEL_VARIANTS_REQUEST_SUCCESS, CREATE_BIKE_MODEL_VARIANTS_REQUEST_FAILURE } from '../constants/create_bike_model_variant.constants';

const prefix = 'CREATE';
export const createBikeModelVariantRequest = (params, _id) => ({
    type: CREATE_BIKE_MODEL_VARIANTS_REQUEST, params, _id, prefix,
});

export const createBikeModelVariantRequestSuccess = payload => ({
    type: CREATE_BIKE_MODEL_VARIANTS_REQUEST_SUCCESS, payload, prefix,
});

export const createBikeModelVariantRequestFailure = error => ({
    type: CREATE_BIKE_MODEL_VARIANTS_REQUEST_FAILURE, error, prefix,
});



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Bike_variant_create/redux/actions/create_bike_model_variant.actions.js